export const ICON_PATH = `${process.env.PUBLIC_URL}/static/icons`;

export const ERROR_TYPES = Object.freeze({
  wt: 'Wrong Term',
  se: 'Syntactic Error',
  om: 'Omission',
  sa: 'Word Structure',
  sp: 'Misspelling',
  pe: 'Punctuation Error',
  co: 'Compliance Error',
});

export const SEVERITIES_LISA = Object.freeze({
  min: 'Minor',
  maj: 'Major',
});

export const SEVERITIES_MQM = Object.freeze({
  low: 'Low',
  med: 'Medium',
  cri: 'Critical',
});

export const SEVERITIES_BY_GOCHECK_VERSION = Object.freeze({
  lisa_v4: SEVERITIES_LISA,
  mqm_v1: SEVERITIES_MQM,
});

export const ANNOTATION_TYPES = Object.freeze({
  issue: 'issue',
  suggestion: 'suggestion',
});
